let bundleBtn = document.querySelector('.bundle-button')
let bundleIDs = bundleBtn.dataset.bundleItems
let bundlesData = JSON.parse(bundleIDs.replace('},]}', '}]}'))
let url = window.location.origin

async function addBundlesToCart() {
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bundlesData),
  })
    .then((response) => {
      return response.json()
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}
async function goToCart() {
  await this.addBundlesToCart()
  location.assign(url + '/cart')
}

bundleBtn.addEventListener('click', () => goToCart())
